import {generateActions} from "../generateActions";
import {eTongHopSinhVienActionsObj} from "./../../action-types/report/ITongHopSinhVienActionTypes";

export const tongHopSinhVienActions = {
    ...generateActions(eTongHopSinhVienActionsObj, "TONG_HOP_SINH_VIEN"),
};
